<template>
  <!--srcviewscompanydetailsBusinessActivitiesSupplyChainvuehtmlStart-->

  <div id="defaultId1 " class="margin-bottom10">
    <div id="g2ede8" class="operations-content">
      <h2 id="gf7b16" class="operations-head-content">
        <div>
          <span class="operations-headspan"> Trade Trends </span>
        </div>

        <div class="flex_between_box">
          <div class="perations-content-left margin-left20">
            <span
              :class="
                activeIEports == '1'
                  ? 'perations-button perations-button-active'
                  : 'perations-button'
              "
              @click="ceckIEports('1')"
            >
              Imports</span
            >
            <span
              @click="ceckIEports('2')"
              :class="
                activeIEports == '2'
                  ? 'perations-button perations-button-active'
                  : 'perations-button'
              "
              >Exports</span
            >
          </div>
        </div>
      </h2>

      <div class="Product_Supply_select flex_center_bettwen">
        <div class="">
          <el-date-picker
            v-model="datePicker"
            class="date_picker"
            @change="getTradeTrendsFilterList(2)"
            type="monthrange"
            range-separator=""
            start-placeholder="Start date"
            value-format="yyyy-MM"
            end-placeholder="End date"
          ></el-date-picker>
          <el-select
            @change="getTradeTrendsFilterList(1)"
            class="supply_select search-select-con margin-left20"
            filterable
            :popper-append-to-body="false"
            v-model="HsCode"
            placeholder="Enter HS Code &  Product Name"
          >
            <el-option
              v-for="(item, index) in HsCodeList"
              :key="index"
              :label="item.nameEn"
              :value="item?.code"
            >
              <el-tooltip
                effect="light"
                :content="item.nameEn"
                placement="top"
                :visible-arrow="false"
                :disabled="item?.nameEn?.length < 40"
              >
                <span
                  style="display: block; max-width: 100%; line-height: auto"
                  class="Country_name"
                >
                  {{ item.nameEn }}</span
                >
              </el-tooltip>
            </el-option>
          </el-select>
          <el-select
            @change="getTradeTrendsFilterList(2)"
            v-model="Country"
            :visible-arrow="false"
            placeholder="Select Country"
            class="supply_select search-select-con margin-left20"
          >
            <el-option
              v-for="(item, index) in Countryoptions"
              :key="index"
              :label="item.nameEn"
              :value="item?.code"
            >
            </el-option>
          </el-select>
        </div>
        <el-button
          style="background: #009ea7 !important"
          class="btn_export"
          @click="getTradeTrendsFilterList(0)"
        >
          Reset</el-button
        >
      </div>

      <div class="margin-top20">
        <div ref="SupplyChainEchart" style="width: 100%; height: 540px"></div>
      </div>
    </div>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
</template>

<script>
import {
  showTradeTrendsOfTargetCountries,
  getTradeTrendsFilter,
  getTradeTrends,
} from "@/api/companyApi.js";
import ReLogin from "../../../../components/ReLogin.vue";
export default {
  name: "",
  components: {
    ReLogin,
  },
  data() {
    return {
      data: {
        links: [],
        nodes: [],
      },
      Importyear: "",
      Country: "",
      companyList: [],
      Companyid: "",
      HsCodeList: [],
      HsCode: "",

      Countryoptions: ["China", "Japan", "Germany", "France", "Canada"],
      datePicker: ["2025-01", "2025-12"],

      activeIEports: "1",
      importTrendListEcharts: [],

      reLoginVis: false,
    };
  },
  mounted() {
    this.getTradeTrendsFilterList(0);
    window.addEventListener("resize", this.resizeFn);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeFn);
  },
  methods: {
    resizeFn() {
      this.suppleEchart();
    },
    SelectPicker() {
      this.datePicker = this.datePicker.sort(function (a, b) {
        return a - b;
      });
      this.getTradeTrendsFilterList(0);
    },
    ceckIEports(row) {
      this.activeIEports = row;
      this.getTradeTrendsFilterList(0);
    },
    getTradeTrendsFilterList(value) {
      if (value == 0) {
        this.datePicker = ["2025-01", "2025-12"];
        this.HsCode = "";
        this.Companyid = "";
        this.Country = "";
      }
      if (value == 1) {
        this.Companyid = "";
        this.Country = "";
      }

      getTradeTrendsFilter({
        startMonth: this.datePicker[0],
        type: this.activeIEports,
        endMonth: this.datePicker[1],
        modelType: 3,
        hsCode: this.HsCode,
        countryCode: this.$route.query.id3a,
      }).then((res) => {
        if (res.code == 200) {
          this.HsCodeList = res.data.hsCodeList;
          this.companyList = res.data.companyList;
          this.Countryoptions = res.data.countryList;
          if (value == 0) {
            this.HsCode = res.data.hsCodeList[0].code;
            this.Country = res.data.countryList[0].code;
          }
          if (value == 1 && this.HsCode) {
            this.Country = res.data.countryList[0].code;
          }
          this.getData();
        }
      });
    },

    suppleEchart() {
      let that = this;
      this.echartsBox = this.$echarts.init(this.$refs.SupplyChainEchart);
      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },

        grid: {
          left: "0%", // 设置左侧边距
          right: "0%",
          top: "7%",
          bottom: "0%",
          containLabel: true,
        },
        legend: {
          right: "10px",
          top: "0px",
          itemGap: 40,
          // 其他图例配置项
          // ...
        },
        xAxis: {
          type: "category",
          data: that.importTrendListEcharts.map((item) => item.impYearMonth),
          axisTick: {
            show: false, // 不显示 x 轴上的间隔点
          },
          axisLabel: {
            color: "#1A2332", // 设置字体颜色
            fontSize: 14, // 可以在这里设置字体大小
            fontWeight: "normal", // 字体粗细
            fontFamily: "Arial, Arial", // 字体类型,
          },

          axisLine: {
            show: true,
            lineStyle: {
              width: 1,

              color: "#8497AB",
            },
          },
        },
        yAxis: [
          {
            type: "value",
            splitNumber: 4,
            // inverse: true,
            axisLine: {
              show: true,
              // 横坐标轴颜色
              lineStyle: {
                width: 1,

                color: "#8497AB",
              },
            },

            // 背景虚线
            splitLine: {
              lineStyle: {
                width: 1,
                type: "dashed",
                color: "#8398BB",
              },
            },
            axisLabel: {
              show: true,
              color: "#1A2332", // 设置字体颜色
              fontSize: 14, // 可以在这里设置字体大小
              fontWeight: "normal", // 字体粗细
              fontFamily: "Arial, Arial", // 字体类型,
              formatter: function (value) {
                return value.toLocaleString(); // 格式化为千分位
              },
            },
          },

          {
            type: "value",
            position: "right",
            alignTicks: true,
            axisLine: {
              show: true,
              // 横坐标轴颜色
              lineStyle: {
                width: 1,

                color: "#8398BB",
              },
            },
            // max:  that.ExporttableData.reduce((max, item) => (item.transactions > max ? item.transactions : max),  that.ExporttableData[0].transactions),
            axisLabel: {
              show: true,
              color: "#1A2332", // 设置字体颜色
              fontSize: 14, // 可以在这里设置字体大小
              fontWeight: "normal", // 字体粗细
              fontFamily: "Arial, Arial", // 字体类型,
              formatter: function (value) {
                return value.toLocaleString() + "%"; // 格式化为千分位
              },
              color: "#FF7600", // 这里设置颜色，比如红色
            },
          },
        ],
        series: [
          {
            name: "Trade Volume",
            type: "bar",
            barWidth: "50",
            itemStyle: { color: "#009EA7", barBorderRadius: [5, 5, 0, 0] },
            barCategoryGap: "20%",
            emphasis: {
              itemStyle: {
                color: "#009EA7",
              },
            },
            tooltip: {
              valueFormatter: function (value) {
                if (value != null) {
                  return "USD " + value.toLocaleString();
                } else {
                  return "-";
                }
              },
            },
            data: that.importTrendListEcharts.map((item) => item.amount),
          },
          {
            name:
              that.activeIEports == "1"
                ? "Month on Month Ratio"
                : "Month on Month Ratio",
            type: "line",
            itemStyle: { color: "#FF7600" },
            yAxisIndex: 1,

            tooltip: {
              valueFormatter: function (value) {
                if (value != null) {
                  return value + "%";
                } else {
                  return "-";
                }
              },
            },
            data: that.importTrendListEcharts.map((item) => {
              // 判断值来决定图标和颜色
              const isAbove20 = item.growthRate > 0;

              return {
                value: item.growthRate,
                symbol: isAbove20
                  ? "path://M0,10 L10,0 L20,10 Z"
                  : "path://M0,0 L10,10 L20,0 Z", // 向上或向下三角形
                symbolSize: 20, // 设置大小
                itemStyle: {
                  color: isAbove20 ? "#FF6A6A" : "#1EFF0D", // 大于20为红色三角形，小于20为蓝色
                },
              };
            }),
          },
        ],
      };
      this.echartsBox.setOption(option);
      this.$nextTick(() => {
        this.echartsBox.resize();
      });
    },
    getData() {
      getTradeTrends({
        startMonth: this.datePicker[0],
        type: this.activeIEports,
        endMonth: this.datePicker[1],
        modelType: 3,
        hsCode: this.HsCode,
        countryCode: this.$route.query.id3a,
        countryCodeFilter: this.Country,
      }).then((res) => {
        if (res.code == 200) {
          this.importTrendListEcharts = res.data;

          this.suppleEchart();
        }
      });
    },
  },
  computed: {},
};
</script>
<style scoped>
.operations-content {
  padding: 30px 40px;
  height: 100%;
}

.operations-content {
  padding: 30px 40px;
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
}

.table-content-color {
  color: #009ea7;
}

/deep/ .el-range-editor.el-input__inner {
  padding: 0px !important;
}
/deep/ .el-date-editor .el-range__close-icon {
  display: none !important;
}
/deep/ .el-tag.el-tag--info {
  background-color: transparent !important;
  border-color: transparent !important;
  color: #1a2332;
  font-size: 1.285714rem;
}

.Product_Supply_select {
  padding: 20px;
  background: #f5f5f5;
  border-radius: 5px;
}
.Product_Supply_select >>> .el-range-input {
  font-size: 16px;
}
/*cssStart*/
/deep/ .el-select-dropdown {
  max-width: 400px;
}
/*cssEnd*/
.font26 {
  font-size: 26px !important;
}
.btn_export {
  border-radius: 5px;
  font-size: 16px;
  min-width: 120px;
  padding: 10px 20px;
}
@media (max-width: 1920px) {
  .operations-content {
    padding: 22px 30px;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
  }
  .Product_Supply_select {
    padding: 15px;
    border-radius: 5px;
  }

  .supply_select {
    width: 292px;
  }
  .map_select >>> .el-input__inner {
    font-size: 16px;
  }
  .Product_Supply_select >>> .el-range-input {
    font-size: 14px;
  }
  .font26 {
    font-size: 20px !important;
  }
  .btn_export {
    font-size: 14px;
    min-width: 90px;
    padding: 9px 20px;
  }
}
@media screen and (max-width: 1439px) {
  .operations-content {
    padding: 20px 26px;
    box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.12);
  }
  .Product_Supply_select {
    padding: 13px;
    border-radius: 5px;
  }

  .map_select >>> .el-input__inner {
    font-size: 14px;
  }
  .Product_Supply_select >>> .el-range-input {
    font-size: 16px;
  }
  .font26 {
    font-size: 18px !important;
  }
}
</style>
